"use client"
/* */
import { autorun } from 'mobx';
import { useState, useEffect } from 'react';

const useSelector = (select, deps = []) => {
  const [selected, setSelected] = useState(select());
  useEffect(() => {
    return autorun(() => {
      setSelected(select());
    });
  }, deps);
  return selected;
};

export { useSelector as default, useSelector };
//# sourceMappingURL=useSelector.mjs.map
